import React from 'react';
import Svg, {Path} from 'react-native-svg';
import {Props} from '../SvgProps';

const PartsAssignedIcon = ({color = '#008236'}: Props) => {
  return (
    <Svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <Path
        d="M5.5 10.864C5.65202 10.9517 5.82446 10.9979 6 10.9979C6.17554 10.9979 6.34798 10.9517 6.5 10.864L10 8.86397C10.1519 8.77629 10.278 8.65022 10.3658 8.49839C10.4535 8.34657 10.4998 8.17434 10.5 7.99897V3.99897C10.4998 3.82361 10.4535 3.65138 10.3658 3.49956C10.278 3.34773 10.1519 3.22166 10 3.13397L6.5 1.13397C6.34798 1.04621 6.17554 1 6 1C5.82446 1 5.65202 1.04621 5.5 1.13397L2 3.13397C1.84813 3.22166 1.72199 3.34773 1.63423 3.49956C1.54647 3.65138 1.50018 3.82361 1.5 3.99897V7.99897C1.50018 8.17434 1.54647 8.34657 1.63423 8.49839C1.72199 8.65022 1.84813 8.77629 2 8.86397L5.5 10.864Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 11V6"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M1.64453 3.5L5.99953 6L10.3545 3.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M3.75 2.13672L8.25 4.71172"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default PartsAssignedIcon;
